  
  
    function myfun(handle) {
      const location = `/products/${handle}`;
      if (window.location.pathname !== location) {
        window.location.href = location;
      }
    }
  
      const rel_swiper = new Swiper('.feat-prod-swiper', {
        direction: 'horizontal',
        loop: false,
        pagination: {
          el: '.feat-prod-dots',
          clickable: true,
        },
        slidesPerView: 1,
        spaceBetween: 25,
        freeMode: true,
        mousewheel: {
          forceToAxis: true, // Ensures scrolling only moves horizontally
          sensitivity: 2, // Adjusts scroll speed (increase if needed)
          releaseOnEdges: true, // Allows scrolling to stop at edges
        },
        breakpoints: {
          400: {
            slidesPerView: 1.2,
          },
          450: {
            slidesPerView: 1.4,
          },
          500: {
            slidesPerView: 1.6,
          },
          640: {
            slidesPerView: 2,
          },
          768: {
            slidesPerView: 2.4,
          },
          1024: {
            slidesPerView: 3,
          },
          1280: {
            slidesPerView: 3.5,
          },
          1440: {
            slidesPerView: 4,
          },
        },
      });



 



